export default __webpack_public_path__ + "static/media/regulatory--vehicles-carrying-hazardous-goods-permitted--g1.e45be8b9.png";